import { createMuiTheme } from '@material-ui/core/styles';

const values: any = {
  xs: 360,
  sm: 600,
  md: 960,
  ml: 910,
  lg: 1280,
  xl: 1440,
};

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00CAA6',
    },
    secondary: {
      main: '#00CAA6',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      text: {
        // Some CSS
        color: 'white',
        background: '#00AAE4',
        borderRadius: 50,
        letterSpacing: 0.3,
        fontFamily: '"Mulish", sans-serif',
      },
    },
    MuiSelect: {
      iconOutlined: {
        right: '20px',
        color: '#9B9B9B',
      },
    },
  },
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    up: (key: any) => {
      const value = values[key];
      return `@media (min-width:${value}px)`;
    },
  },
  props: {
    // Name of the component
    MuiButtonBase: {
      // The default props to change
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
    MuiAccordion: {
      elevation: 0,
    },
    MuiCard: {
      elevation: 0,
    },
  },
  typography: {
    subtitle1: {
      fontFamily: 'Prompt',
      fontWeight: 700,
      fontStyle: 'normal',
      color: '#171C1B',
    },
    subtitle2: {
      fontFamily: 'Mulish',
      fontWeight: 700,
      fontStyle: 'normal',
      color: '#171C1B',
    },
    body2: {
      fontFamily: 'Mulish',
      fontWeight: 400,
      fontStyle: 'normal',
      color: '#9B9B9B',
    },
    body1: {
      fontFamily: 'Mulish',
      fontWeight: 400,
      fontStyle: 'normal',
      color: '#171C1B',
    },
    caption: {
      fontFamily: 'Prompt',
      fontStyle: 'normal',
      fontWeight: 700,
      color: '#9B9B9B',
    },
  },
});
export default theme;
